import { render, staticRenderFns } from "./Sidebar3.vue?vue&type=template&id=ded69c8c&scoped=true&"
import script from "./Sidebar3.vue?vue&type=script&lang=js&"
export * from "./Sidebar3.vue?vue&type=script&lang=js&"
import style0 from "./Sidebar3.vue?vue&type=style&index=0&id=ded69c8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded69c8c",
  null
  
)

/* custom blocks */
import block0 from "./Sidebar3.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports